var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoimg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 43,
    viewBox: "0 0 46 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 43,
    rx: 5,
    fill: "#F7FAFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_655_3538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8381 13.7744H12.0635C10.3786 13.7744 9 15.153 9 16.8379V27.1617C9 28.8466 10.3786 30.2252 12.0635 30.2252H24.8381C26.523 30.2252 27.9015 28.8466 27.9015 27.1617V16.8379C27.9015 15.1223 26.523 13.7744 24.8381 13.7744Z",
    fill: "#18406D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7334 15.4595C34.5496 15.4901 34.3658 15.582 34.2126 15.6739L29.4336 18.4311V25.5383L34.2432 28.2954C35.1316 28.8162 36.2345 28.5098 36.7553 27.6214C36.9084 27.3457 37.0003 27.0394 37.0003 26.7024V17.2363C37.0003 16.1028 35.9281 15.1838 34.7334 15.4595Z",
    fill: "#18406D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_655_3538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoimg);
export default __webpack_public_path__ + "static/media/videoimg.b9a1d3b575ff65d28070d2f1a9560d36.svg";
export { ForwardRef as ReactComponent };